var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_vm._m(0),_c('div',{staticClass:"nav"},[_c('el-menu',{staticClass:"nav-content",attrs:{"default-active":_vm.activeIndex,"text-color":"#000000","mode":"horizontal","active-text-color":"#053780"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/m"}},[_vm._v("首页")]),_c('el-menu-item',{class:_vm.activeIndex == '/m-introduction/idea' ||
          _vm.activeIndex == '/m-introduction/os' ||
          _vm.activeIndex == '/m-introduction/rules' ||
          _vm.activeIndex == '/m-introduction/committee'
            ? 'actionStyle'
            : '',attrs:{"index":"/m-introduction/idea"}},[_vm._v(" 专委会介绍 ")]),_c('el-menu-item',{class:_vm.activeIndex == '/m-news/list' ||
          _vm.activeIndex == '/m-news/notice' ||
          _vm.activeIndex == '/m-news/policyNews'
            ? 'actionStyle'
            : '',attrs:{"index":"/m-news/list"}},[_vm._v(" 新闻动态 ")]),_c('el-menu-item',{class:_vm.activeIndex == '/m-kb/doc' ||
          _vm.activeIndex == '/m-kb/term' ||
          _vm.activeIndex == '/m-kb/codePractice'
            ? 'actionStyle'
            : '',attrs:{"index":"/m-kb/doc"}},[_vm._v(" 技术专区 ")]),_c('el-menu-item',{class:_vm.activeIndex == '/m-centigrade/introduce' ||
          _vm.activeIndex == '/m-centigrade/rights'
            ? 'actionStyle'
            : '',attrs:{"index":"/m-centigrade/introduce"}},[_vm._v(" 成员服务 ")])],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('a',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"href":"/m"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})])])
}]

export { render, staticRenderFns }